/// <reference path="../wpt.ts" />
/// <reference path="../../modules/logonWrapper/logonWrapperCommon.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Components.LogonHandler";
        class ComponentLogonHandler extends Widgets.ComponentBaseClass {
            constructor(core, container, parent, startLogonCallback) {
                super(core, container, parent);
                this._commonLoaded = null;
                this._iframeHolder = null;
                this._origin = null;
                this._logonWindow = null;
                this._isReady = null;
                this._startLogonCallback = null;
                this._logonData = null;
                this._isWaitingShowLogon = null;
                this.showLogonPage = (logonData) => {
                    this._log.info("LogonHandlerComponent.showLogonPage()");
                    this._logonData = logonData;
                    if (this._isReady) {
                        this._showLogon();
                    }
                    else {
                        this._isWaitingShowLogon = true;
                    }
                };
                this.clearLogonPage = () => {
                    this._log.info("LogonHandlerComponent.clearLogonPage()");
                    if (this._iframeHolder) {
                        this._iframeHolder.innerHTML = "";
                        this._iframeHolder.src = "";
                    }
                };
                this._commonJavascriptLoaded = () => {
                    this._log.info("LogonHandlerComponent._commonJavascriptLoaded()");
                    this._commonLoaded = true;
                    if (ComponentLogonHandler.Html != null) {
                        this._readyToPresent = true;
                        if (this._waitingToPresent)
                            this._present();
                    }
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("LogonHandlerComponent._storeHtml()");
                    ComponentLogonHandler.Html = htmlData;
                    if (this._commonLoaded) {
                        this._readyToPresent = true;
                        if (this._waitingToPresent)
                            this._present();
                    }
                };
                this._messageHandler = (event) => {
                    this._log.info("LogonHandlerComponent._messageHandler()");
                    if (this._parent && this._log.isTraceEnabled()) {
                        this._log.trace("message for " + this._parent.getHandle());
                    }
                    // check origin
                    if (event.origin != this._origin) {
                        console.warn("got message from unexpected origin: " + event.origin);
                        return;
                    }
                    // check source
                    if (event.source != this._logonWindow) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got message from unexpected source: " + event.source);
                        }
                        return;
                    }
                    let message = event.data;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("looking at command: " + WPTNamespace.Utilities.Logon.WrapperCommand[message.Command]);
                    }
                    switch (message.Command) {
                        case WPTNamespace.Utilities.Logon.WrapperCommand.READY:
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("wrapper is ready");
                            }
                            let logonContent = {
                                Command: WPTNamespace.Utilities.Logon.WrapperCommand.LOGON_CONTENT,
                                Content: this._logonData,
                                LangCode: this._core.Locale.getSelectedLocale().LangFileCode,
                                Locale: this._core.Locale.getSelectedLocale().LocaleCode
                            };
                            this._logonWindow.postMessage(logonContent, this._origin);
                            break;
                        case WPTNamespace.Utilities.Logon.WrapperCommand.LOGON_FINISHED:
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("got logon finished");
                            }
                            break;
                        case WPTNamespace.Utilities.Logon.WrapperCommand.START_LOGON:
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("got start logon");
                            }
                            if (this._startLogonCallback) {
                                this._startLogonCallback();
                            }
                            break;
                        case WPTNamespace.Utilities.Logon.WrapperCommand.SIZE_CHANGED:
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("got size response");
                            }
                            let sizeMsg = message;
                            this._iframeHolder.style.height = sizeMsg.Height + "px";
                            break;
                        case WPTNamespace.Utilities.Logon.WrapperCommand.LOGON_SCRIPT_LOAD_FAILED:
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("got script load error");
                            }
                            if (this._parent) {
                                let scriptLoadFailedMsg = message;
                                let loadMsg = this._core.Locale.getTranslation("STR_WPT_LOGONSCRIPT_LOAD_FAILED_MSG") + ": " + scriptLoadFailedMsg.ScriptName;
                                this._parent.addError(loadMsg);
                            }
                            break;
                        case WPTNamespace.Utilities.Logon.WrapperCommand.LOGON_SCRIPT_EVAL_FAILED:
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("got script eval error");
                            }
                            if (this._parent) {
                                let scriptEvalFailedMsg = message;
                                let evalMsg = this._core.Locale.getTranslation("STR_WPT_LOGONSCRIPT_EVAL_FAILED_MSG") + ": " + scriptEvalFailedMsg.ScriptError.name + " - " + scriptEvalFailedMsg.ScriptError.message;
                                this._parent.addError(evalMsg);
                            }
                            break;
                        default:
                            console.warn("unknown command: " + WPTNamespace.Utilities.Logon.WrapperCommand[message.Command]);
                            break;
                    }
                };
                this._showLogon = () => {
                    this._log.info("LogonHandlerComponent._showLogon()");
                    if (this._isReady) {
                        this._iframeHolder.src = './assets/wpt/html/logonWrapper.html?ver=' + this._core.getGatewayVersion();
                    }
                    else {
                        this._isWaitingShowLogon = true;
                    }
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("LogonHandlerComponent::constructor");
                this._startLogonCallback = startLogonCallback;
                this._isReady = false;
                this._commonLoaded = false;
                this._isWaitingShowLogon = false;
                // TODO: add exception handling
                core.Loader.loadVersionedJS('./assets/wpt/js/modules/logonWrapper/logonWrapperCommon.min.js', this._commonJavascriptLoaded);
                if (!ComponentLogonHandler.Html) {
                    core.Loader.getVersionedHTML('widgets/components/logonHandler.html', this._storeHtml, core.Helper.missingHtmlErrorCallback);
                }
                else if (this._commonLoaded) {
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                }
            }
            _present() {
                this._log.info("LogonHandlerComponent._present()");
                this._container.innerHTML = ComponentLogonHandler.Html;
                this._iframeHolder = this._container.querySelector('#logonContentHolder');
                this._origin = window.origin;
                this._logonWindow = this._iframeHolder.contentWindow;
                window.addEventListener('message', this._messageHandler);
                this._isReady = true;
                if (this._log.isTraceEnabled()) {
                    this._log.trace("logon handler ready, checking actions waiting...");
                }
                if (this._isWaitingShowLogon) {
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("showing logon...");
                    }
                    this._showLogon();
                }
            }
        }
        ComponentLogonHandler.Html = null;
        Widgets.ComponentLogonHandler = ComponentLogonHandler;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
